module.exports = __webpack_public_path__ + "static/img/logo.cddf2077.png";